import { useMedia } from "react-use";
import { MOBILE_MAX_WIDTH } from "../../../constant";
import CloseSvg from "../../common/ui/CloseSvg";
import NormalAnimatedBtn from "../../common/ui/NormalAnimatedBtn";

type Props = {
  count: number;
  reset: () => void;
};

const ResetFilterCondTag = ({ count, reset }: Props) => {
  const isMobile = useMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`, false);

  return (
    <div className={isMobile ? "mt-[8px] ml-[8px]" : ""}>
      <NormalAnimatedBtn
        onClick={reset}
        extraClass={`py-[12px] px-[16px] flex gap-[8px] ${
          isMobile ? "" : "ml-[16px]"
        }`}
      >
        <span className="text-[16px] leading-[16px]">
          {isMobile ? "" : "RESET"}({count})
        </span>
        <div className="w-[14px] h-[14px]">
          <CloseSvg size="14" />
        </div>
      </NormalAnimatedBtn>
    </div>
  );
};

export default ResetFilterCondTag;
